module.exports = __webpack_public_path__ + "static/img/ap10.04a560e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap10.jpg
// module id = snTZ
// module chunks = 1